module.exports = __webpack_public_path__ + "static/media/notification.7b0b6531.svg";